import * as React from 'react';
import { Drawer as DrawerPrimitive } from 'vaul';

import './vaul-drawer.css';

export function Drawer({
    // This prop is the devil, do not use.
    // Setting this to `true` will mess with the inputs on mobile.
    // https://vaul.emilkowal.ski/inputs#no-repositioning
    repositionInputs = false,
    ...props
}: React.ComponentProps<typeof DrawerPrimitive.Root>) {
    return (
        <DrawerPrimitive.Root
            data-slot="drawer"
            repositionInputs={repositionInputs}
            {...props}
        />
    );
}
